var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEuro = function SvgEuro(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.6 640.1h-95.1v-84.5l86-6c-1.5-15.1-1.5-30.2-1.5-46.8 0-15.1 0-30.2 1.5-43.8h-86v-84.5l95.1-6C271.3 136 416.3 1.6 615.4 1.6c90.6 0 178.2 45.3 235.4 117.7l-98.1 95.1c-39.2-45.3-84.5-77-141.8-77-108.7 0-181.2 84.5-205.3 229.4h353.2V459H396.7c-1.5 12.1-1.5 24.2-1.5 37.7 0 18.1 0 34.7 1.5 51.3h301.8v92.1H407.2c27.1 140.4 98 221.9 200.7 221.9 64.9 0 113.1-33.2 158.5-95.1l98.1 90.6c-69.5 89-156.9 140.3-267.1 140.3-184.2 0-326.1-126.8-366.8-357.7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEuro);
export default ForwardRef;